import styled from "styled-components";

export const AlipayIcon = styled.span`
  display: inline-block;
  width: 30px;
  height: 30px;
  vertical-align: top;
  background: url('//kanimg.niu.niuxyx.com/niuxwebsite/11/pay/img/logo/spr24_logo.png') no-repeat 0 -175px;
  margin-right: 10px;
`;
export const WechatPayIcon = styled.span`
  display: inline-block;
  width: 30px;
  height: 30px;
  vertical-align: top;
  background: url('//kanimg.niu.niuxyx.com/niuxwebsite/11/pay/img/logo/spr24_logo.png') no-repeat -50px -175px;
`;
export const PaymentTipArrow = styled.div`
  position: absolute;
  left: -70px;
  top: 10px;
  width: 58px;
  height: 70px;
  background: url('//kanimg.niu.niuxyx.com/niuxwebsite/11/pay/img/ico_spr.png') no-repeat -300px 0;
`
export const PaymentTilContent = styled.div`
  position: absolute;
  left: 230px;
  bottom: 26px;

  font-size: 12px;
  line-height: 1.6;
  color: #969696;


  a {
    color: #969696;
  }
`;